import { XStack, Theme, SimpleText, useWindowDimensions, Image } from '@my/ui';
import { MenuLogo } from './Logos'
export * from './Logos';

export const MenuButton = ({ onPress }) => {
  const { width } = useWindowDimensions()
  return (
    <>
      <MenuLogo onPress={onPress} />
      {width > 500 && (
        <SimpleText marginHorizontal={9} fontSize={16} fontFamily={'$body'} color="#85C19D">
          Menu
        </SimpleText>
      )}
    </>
  )
}